module.exports = __webpack_public_path__ + "img/22072901.96230106.jpg";